import EfImg from '@elem/ui/ef-img';
import GloLayout from 'lowcode/common/GloLayout';
import './index.scss';

export default function Content({ id, data = {} }: any) {
    const { pc, h5, title, desc } = data;
    const compStyle = {};
    return (
        <GloLayout className={`editor-blog-author`} id={id} style={compStyle}>
            <div className="editor-blog-author-in">
                <div className="editor-blog-author-img">
                    <EfImg pc={pc} h5={h5} />
                </div>
                <div className="editor-blog-author-msg">
                    <div className="editor-blog-author-title">{title}</div>
                    <div className="editor-blog-author-desc">{desc}</div>
                </div>
            </div>
        </GloLayout>
    );
}
